import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `banners`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "prepend",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `banners/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const updateStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `banners/status/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `banners/${args?.id}`,
      method: "delete",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Deleted successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `banners/${args?.id}`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 600000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "banners",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 600000,
    };
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const removeBanner = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `banners/image/${args?.id}`,
      method: "delete",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
export default {
  find,
  list,
  create,
  update,
  remove,
  removeBanner,
  updateStatus,
};
